import { getApp } from "firebase/app";
import { getFunctions, httpsCallable } from "firebase/functions";

let tried = false;

export async function tryWpnBackfill(lat: number, lng: number, radiusM: number) {
  if (import.meta.env.VITE_LGS_WPN_BACKFILL_ENABLED !== "true") return false;
  if (tried) return false; // avoid rapid repeats within session
  tried = true;
  try {
    const radiusMi = Math.max(1, Math.round(radiusM / 1609.34));
    const fn = httpsCallable(
      getFunctions(getApp(), undefined),
      "fetchWpnStores"
    );
    const res: any = await fn({ lat, lng, radiusMi });
    if (import.meta.env.DEV) {
      console.debug("[lgs] WPN backfill result", res?.data);
    }
    return true;
  } catch (e) {
    console.warn("[lgs] WPN backfill failed", e);
    return false;
  }
}
